import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TaskFilterForm } from '../../components/shared/models/TaskFilterForm';
import { Page } from '../model/page';
import { Task } from '../../components/account/models/Task';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  private taskUrl = environment.baseUrl + '/task';

  constructor(
    private http: HttpClient
  ) { }

  getTask(taskId: number): Observable<any> {
    return this.http.get<any>(this.taskUrl + `/${taskId}`);
  }

  getAnreTasks(): Observable<any[]> {
    return this.http.get<any[]>(this.taskUrl + '/anre');
  }

  getOperatorTasks(taskFilterForm: TaskFilterForm): Observable<Page<Task>> {
    return this.http.post<Page<Task>>(this.taskUrl + '/operator', taskFilterForm);
  }

  getSupplierTasks(taskFilterForm: TaskFilterForm): Observable<Page<Task>> {
    return this.http.post<Page<Task>>(this.taskUrl + '/supplier', taskFilterForm);
  }

  assignTask(taskId: number): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/task/${taskId}/assign`, {});
  }

  resolveTask(taskId: number, task: any): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/task/${taskId}/resolve`, task);
  }

  resolveTaskFurnizorMotiv(taskId: number, reason: string): Observable<void> {
    return this.http.put<void>(this.taskUrl + `/${taskId}/furnizor/motiv`, reason);
  }

  resolveTaskFurnizorSemnatura(taskId: number, signature: any): Observable<void> {
    return this.http.put<void>(this.taskUrl + `/${taskId}/furnizor/semnatura`, signature);
  }

  resolveTaskOperatorSemnatura(taskId: number, taskResolution: any): Observable<void> {
    return this.http.put<void>(this.taskUrl + `/${taskId}/operator/semnatura`, taskResolution);
  }
}
